import { SvgIcon } from '@mui/material';
import React from 'react';

const MPBricomanIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        id="Bricoman"
        data-name="Bricoman"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 43 21"
        strokeWidth={0}
        fill="currentColor"
      >
        <title>Bricoman</title>

        <path d="M40 7H3V14H40V7Z" fill="#120949" />
        <path
          d="M7.59373 10.6545V10.623C7.76292 10.563 7.9074 10.4526 8.00578 10.308C8.10416 10.1634 8.1512 9.99244 8.13994 9.82034C8.13994 8.90265 7.31796 8.71805 6.51193 8.71805H4.7515V12.6943H6.8101C7.53801 12.6943 8.33312 12.415 8.33312 11.5974C8.33716 11.3839 8.26668 11.1751 8.13279 11.0042C7.99889 10.8332 7.80923 10.7097 7.59373 10.6532M6.09786 9.60978H6.2328C6.47526 9.60978 6.79106 9.62743 6.79022 9.95197C6.79022 10.2711 6.51725 10.2765 6.2748 10.2765H6.09786V9.60978ZM6.31035 11.7884H6.10262V11.0425H6.28684C6.54525 11.0425 6.95876 11.0425 6.95652 11.4128C6.954 11.805 6.57464 11.7873 6.31035 11.7873"
          fill="white"
        />
        <path
          d="M11.5777 11.1664V11.1345C12.1407 10.9553 12.3834 10.7022 12.3834 10.101C12.3834 9.09876 11.5889 8.71912 10.6507 8.71912H8.82391V12.6954H10.2436V11.4192H10.3304L11.0119 12.6954H12.7367L11.8316 11.4034C11.7616 11.3112 11.6757 11.2312 11.5777 11.1664ZM10.3817 10.4756H10.2417V9.69699H10.3934C10.6636 9.69699 10.9699 9.76388 10.9679 10.105C10.9659 10.4279 10.6406 10.4758 10.3819 10.4758"
          fill="white"
        />
        <path
          d="M14.5243 8.71939H13.0122V12.6957H14.5243V8.71939Z"
          fill="white"
        />
        <path
          d="M17.3848 9.93217C17.7232 9.95441 18.0405 10.0977 18.2734 10.3335L18.2291 8.81972C17.9023 8.71266 17.5592 8.65745 17.2137 8.65625C16.9268 8.65488 16.6425 8.70805 16.3774 8.81266C16.1122 8.91726 15.8715 9.07122 15.6691 9.26556C15.4668 9.45991 15.3069 9.69076 15.1988 9.9447C15.0907 10.1986 15.0366 10.4706 15.0395 10.7447C15.0363 11.0105 15.0889 11.2743 15.1941 11.5204C15.2993 11.7665 15.4549 11.99 15.6519 12.1777C15.8488 12.3655 16.0831 12.5136 16.3409 12.6135C16.5987 12.7134 16.8748 12.763 17.1529 12.7593C17.5183 12.763 17.8818 12.7096 18.2291 12.6012L18.2734 11.1139C18.1625 11.2285 18.0284 11.3203 17.8791 11.3838C17.7299 11.4473 17.5688 11.4811 17.4055 11.4831C17.186 11.4866 16.974 11.407 16.8158 11.2616C16.6576 11.1163 16.566 10.9169 16.5611 10.7072C16.5615 10.6046 16.5831 10.5031 16.6247 10.4085C16.6663 10.3139 16.727 10.2281 16.8035 10.156C16.8799 10.0839 16.9704 10.0269 17.07 9.98836C17.1695 9.94982 17.276 9.93045 17.3834 9.93137"
          fill="white"
        />
        <path
          d="M20.9597 8.65598C19.6959 8.65598 18.6583 9.46798 18.6583 10.7179C18.6583 11.9941 19.6906 12.7588 20.9597 12.7588C22.2288 12.7588 23.261 11.9941 23.261 10.7179C23.261 9.46798 22.2234 8.65598 20.9597 8.65598ZM20.9597 11.5037C20.8546 11.5072 20.75 11.4896 20.6524 11.4522C20.5549 11.4147 20.4667 11.3581 20.3934 11.2861C20.3201 11.2141 20.2634 11.1282 20.227 11.034C20.1905 10.9398 20.175 10.8393 20.1816 10.7391C20.1756 10.6384 20.1913 10.5376 20.2278 10.443C20.2643 10.3484 20.3208 10.262 20.3938 10.1892C20.4669 10.1164 20.5548 10.0588 20.6521 10.0199C20.7495 9.98102 20.8542 9.96171 20.9597 9.9632C21.0651 9.96175 21.1698 9.98108 21.2671 10.02C21.3645 10.0589 21.4524 10.1165 21.5254 10.1893C21.5984 10.2621 21.6549 10.3485 21.6914 10.4431C21.7279 10.5377 21.7437 10.6384 21.7377 10.7391C21.7442 10.8393 21.7288 10.9398 21.6923 11.034C21.6558 11.1281 21.5991 11.214 21.5258 11.286C21.4526 11.358 21.3643 11.4146 21.2668 11.4521C21.1693 11.4896 21.0647 11.5072 20.9597 11.5037Z"
          fill="white"
        />
        <path
          d="M30.6258 8.71912L29.1798 12.6954H30.7641L30.8856 12.1996H32.0615L32.1995 12.6954H33.7836L32.2997 8.71912H30.6258ZM31.1463 11.2937L31.4366 9.95357H31.5088C31.5368 10.1328 31.805 11.2937 31.805 11.2937H31.1463Z"
          fill="white"
        />
        <path
          d="M36.8022 8.71912V9.91103C36.8022 10.2487 36.8064 10.7961 36.8064 10.7961L35.5275 8.71912H34.0759V12.6954H35.5219V11.4034C35.5219 11.1396 35.5219 10.684 35.5219 10.684L36.8028 12.6951H38.2485V8.71912H36.8022Z"
          fill="white"
        />
        <path
          d="M28.3516 8.71912L26.5338 10.463L26.2258 10.7573L25.9179 10.463L24.0998 8.71912H24.0807L23.4088 12.6954H24.8711L25.0984 11.2239L26.2261 12.2628L27.332 11.2239L27.5862 12.6954H29.0485L28.3642 8.71912H28.3516Z"
          fill="white"
        />
        <path
          d="M28.2374 8.24048H24.2132L26.2253 10.1706L28.2374 8.24048Z"
          fill="#FF5800"
        />
      </svg>
    </SvgIcon>
  );
};

export default MPBricomanIcon;
